import { useContext, useState } from 'react';
import { LoaderContext } from '../../../../../shared/context/loaderContext';
import { NotificationContext } from '../../../../../shared/context/notificationContext';
import { useCm360Api } from 'shared/const/api-backend';

const useUpdateRefund = () => {
  const { setLoading } = useContext(LoaderContext);
  const [updatedRefund, setUpdatedRefund] = useState(null)
  const { showNotification } = useContext(NotificationContext);
  const API = useCm360Api();

  const updateRefund = async (
    policyId,
    { customerRefundDate, refundMethod },
  ) => {
    setLoading(true);

    try {
      const apiUrl = `/ui-proxy/policies/${policyId}/refund`;
      const body = {
        customerRefundDate,
        refundMethod: refundMethod.value,
      };
      const result = await API.patch(apiUrl, body);
      showNotification('Refund updated successfully', 'success');
      setUpdatedRefund(result.data);
    } catch (error) {
      showNotification('Error updating refund', 'error');
      reportError(error);
    } finally {
      setLoading(false);
    }
  };

  return { updateRefund, updatedRefund };
};

export default useUpdateRefund;
